// extracted by mini-css-extract-plugin
export default {"headerBar":"EditQuestion_headerBar__CUg1M"};